import { useState } from 'react';
import { useFamilyStore } from '@/store/familyStore';
import { useAuthStore } from '@/store/authStore';
import { AddRequest } from '@/types';
import { api } from '@/lib/api/client';

export function useRequests() {
  const { requests, updateRequestStatus } = useFamilyStore();
  const user = useAuthStore((state) => state.user);
  const [selectedRequest, setSelectedRequest] = useState<AddRequest | null>(null);
  const [rejectingRequestId, setRejectingRequestId] = useState<string | null>(null);

  const handleApprove = async (requestId: string, updates?: Partial<AddRequest>) => {
    try {
      await api.post(`api/requests/${requestId}/approve`, { type: 'add_child' });
      updateRequestStatus(requestId, 'approved');
      setSelectedRequest(null);
    } catch (error) {
      console.error('Error approving request:', error);
    }
  };

  const handleReject = async (requestId: string) => {
    try {
      await api.post(`api/requests/${requestId}/reject`, { type: 'add_child' });
      updateRequestStatus(requestId, 'rejected');
      setRejectingRequestId(null);
    } catch (error) {
      console.error('Error rejecting request:', error);
    }
  };

  return {
    requests,
    selectedRequest,
    rejectingRequestId,
    setSelectedRequest,
    setRejectingRequestId,
    handleApprove,
    handleReject,
  };
}